import React from 'react';
import { TextLink } from '@emorg-prd/standard-react';
import ApprovalContact from '../../../models/interfaces/ApprovalContact';

export const contactApproversLabel = (approvers: ApprovalContact[]): string =>
	approvers.length > 1 ? 'Contact Approvers' : 'Contact Approver';

interface ContactApproversProps {
	approvers: ApprovalContact[];
}

export const ContactApprovers: React.FC<ContactApproversProps> = ({ approvers }) => (
	<>
		{approvers.map((approver) => (
			<div key={approver.name} className="current-approver">
				{approver.email ? (
					<TextLink url={`mailto:${approver.email}`} optionalClass="current-approver__link">
						{approver.name}
					</TextLink>
				) : (
					approver.name
				)}
			</div>
		))}
	</>
);
